import React, { useEffect, useRef } from 'react'
import { isBrowser } from '@helpers/env'
import styles from './styles.module.scss'

const renderSezzleScript = () => {
  const existingScript = document.getElementById('sezzle-snippet')
  if (!existingScript) {
    const script = document.createElement('script')
    script.src = '/static/scripts/sezzle-widget.min.js'
    script.id = 'sezzle-snippet'
    document.getElementsByTagName('head')[0].appendChild(script)
  }
}

const options = {
  renderElement: 'sezzle-widget',
  marginTop: 20,
  fontFamily: 'Helvetica, Arial, Verdana',
  fontSize: 13
}

type SezzleProps = {
  price: string
}

function Sezzle({ price }: SezzleProps) {
  const hasInjectedScript = useRef(false)
  useEffect(() => {
    // Inject the Sezzle script once on mount; the effect below handles price
    // updates via alterPrice.
    if (hasInjectedScript.current) return
    hasInjectedScript.current = true

    if (isBrowser()) {
      window.onload = () => {
        if (window.AwesomeSezzle) {
          const renderSezzle = new window.AwesomeSezzle({
            amount: `${price}`,
            ...options
          })
          renderSezzle.init()
        }
      }
      renderSezzleScript()
    }
  }, [price])

  useEffect(() => {
    if (isBrowser() && window.AwesomeSezzle) {
      const renderSezzle = new window.AwesomeSezzle({
        amount: `${price}`,
        ...options
      })
      renderSezzle.alterPrice(price)
    }
  }, [price])

  return <div className={styles.sezzleWidget} id="sezzle-widget" />
}

export default Sezzle
